module.exports = __webpack_public_path__ + "static/adjust-c5517c56c903605de23efbf62ce05fcd.png";